import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-05/lesson-06/task-02";

const task: Slide = {
  title: "How do you expect the sound intensity of the trumpet to change as you move away from it?",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
